import api from './api';

export default {
    index(search= false, sort='asc',paginate= true,page=1, userCountFlag = false){
        return api.get(`${process.env.VUE_APP_URL}/teams` , {params: {search:search , sort:sort , paginate:paginate, page:page, userCountFlag: userCountFlag}});
    },
    create(entity , params){
        return api.post(`${process.env.VUE_APP_URL}/teams/${entity}` , params);
    },
    show(id){
        return api.get(`${process.env.VUE_APP_URL}/teams/${id}`);
    },
    update(id , params){
        return api.put(`${process.env.VUE_APP_URL}/teams/${id}` , params);
    },
    delete(id){
        return api.delete(`${process.env.VUE_APP_URL}/teams/${id}`);
    },
}